import React from "react";
import UserAvatar from "assets/img/avatars/user.png";
import { Table } from 'antd';
import {displayFullName} from '../../../../utils/index';

function TopFarmersByAnimalType({recordList, animalType, ...props}) {

  const columns = [
		{
        title: `Name`,
        dataIndex: 'user_id',
        key: 'user_id',
        width: '35%',
        render:(user_id,record) => 
        <div className="flex items-center gap-2">   
          <img
            className="h-10 w-10 rounded-full"
            src={UserAvatar}
            alt="User Avatar"
          />                      
          <p className="text-sm font-medium text-theme-700 dark:text-white">
            {displayFullName(record)}
          </p>
        </div>
    },
    {
        title: <div className="w-full text-right">Total</div>,
        dataIndex: animalType,
        key: animalType,
        width: '8%',
        render:(_, record) => <div className="w-full text-right">{record?.[animalType] ?? 0 }</div>
    },
  ];

  return (
      <div className="pt-4 w-full overflow-x-scroll px-4 md:overflow-x-hidden overflow-y-auto">

        <Table
          dataSource={recordList}
          columns={columns} 
          rowKey={(record) => record.id}
          pagination={false}
        />

      </div>
  );
}

export default TopFarmersByAnimalType;
